<template lang="pug">

  div

    confirm-dialog(ref="cdConfirmModal" :title="cdParameters.title" :text="cdParameters.text" :buttonPosition="cdParameters.buttonPosition" :width="cdParameters.width" @close="cdMessageResponse")

    //-
      -
      - EDITAR VALOR
      -
      -

    v-dialog(v-model="show" max-width="460px" :persistent="updating === true").customMaxHeight

      .dialogHeader

        .dialogHeaderTitle
          | Editar valor do turno

        .dialogHeaderClose
          .dialogCloseButton.mdi.mdi-close(@click="close()")

      .dialogBody

        .dialogBodyContent

          .createTurnField.createTurnField--first.mb-0
            label.csLabel
              span Valor do turno
            .csFields
              app-money-light(:value="newValue" :blur-event="turnNewValueBlurEvent")

          .createTurnField.createTurnField--last.mt-5
            sos-select(label="Atualizar os plantões que já foram disparados?" :fullscreen="true" fullscreenTitle="Atualizar plantões existentes?" :fullscreenAutoWidth="true" :default="updateMode" @sosSelectChanged="onSelectMode" :items="updateModeOptions")

          .mt-4(v-if="updateMode === 'sim-todos'")
            sos-checkbox(id="agree" label="Estou ciente que todos os plantões da escala (todos os meses e anos) serão atualizados." :labelColor="'seagreen'" :checked="agree" :absolute="true" @click="onAgreeCheckboxClick()" :disabled="updating")

          .mt-5
            sos-button(
              @buttonClick="saveTurnValue()"
              buttonLabel="Salvar"
              buttonIcon="mdi-plus"
              buttonIconSize="20"
              size="medium"
              :color="agree === false && updateMode === 'sim-todos' ? 'default' : 'success'"
              :disabled="agree === false && updateMode === 'sim-todos'"
              :loading="updating"
            )

</template>

<script>

  import { apiUpdateScaleTurnValue, apiUpdateTurnDutiesValue } from '@/services/firebase'

  import confirmDialogMixin from '@/mixins/cd.mixin.js'
  import { valueToTime, getMonthNameByCode } from '@/functions'

  import AppMoneyLight from '@/components/base/AppMoneyLight'
  import SosButton from '@/components/SosButton'
  import SosSelect from '@/components/SosSelect'
  import SosCheckbox from '@/components/SosCheckbox'
  import ConfirmDialog from '@/modals/ConfirmDialog'

  //
  //
  //

  export default {
    name: 'TurnValueEditorModal',

    components: {
      'app-money-light': AppMoneyLight,
      'sos-button': SosButton,
      'sos-select': SosSelect,
      'sos-checkbox': SosCheckbox,
      'confirm-dialog': ConfirmDialog,
    },

    mixins: [
      confirmDialogMixin,
    ],

    data () {
      return {
        show: false,
        updating: false,

        agree: false,
        updateMode: 'nao',

        newValue: 0,

        updateModeOptions: [],

        //
        // OPEN PARAMETERS/ARGUMENTS
        //

        mes: null,
        ano: null,
        groupID: '',
        scaleID: '',
        shiftID: '',
        shifts: [], // JESUS: Parou de escutar em tempo real
      }
    },

    watch: {
      show: {
        immediate: true,
        handler: function (newShow, oldShow) {
          const closing = oldShow === true && newShow === false

          if (closing) {
            // console.log('[TurnValueEditorModal] closing TURN VALUE EDITOR')
            this.clear()
          }
        },
      },
    },

    /* mounted () {
      // console.log('TurnValueEditorModal[turns]:', this.shifts)
    }, */

    methods: {
      //
      // OPEN
      //

      open (args)
      {
        //
        // OPEN PARAMETERS/ARGUMENTS
        //

        this.mes = args.mes
        this.ano = args.ano
        this.groupID = args.groupID
        this.scaleID = args.scaleID
        this.shiftID = args.shiftID || ''
        this.shifts = args.shifts

        this.newValue = args.shiftValue || 0

        //
        //
        //

        const selectedMonthName = getMonthNameByCode(args.mes)

        this.updateModeOptions = [
          { key: 'nao', text: 'Não', value: 'nao' },
          { key: 'sim-todos', text: 'Sim, todos os plantões', value: 'sim-todos' },
          { key: 'sim-mes-atual', text: 'Sim, todos os plantões em ' + selectedMonthName + ' de ' + this.ano, value: 'sim-mes-atual' },
        ]

        //
        //
        //

        this.show = true
      },

      //
      //
      //

      close () {
        if (this.updating === true) return false

        this.show = false
      },

      //
      // CLEAR FIELDS & STATE
      //

      clear ()
      {
        this.updating = false

        this.agree = false
        this.updateMode = 'nao'

        this.newValue = 0

        this.updateModeOptions = []

        // OPEN PARAMETERS/ARGUMENTS
        this.mes = null
        this.ano = null
        this.groupID = ''
        this.scaleID = ''
        this.shiftID = ''
        this.shifts = []
      },

      //
      // GUARDA AS ALTERAÇÕES DO USUÁRIO NO STATE DO COMPONENTE
      //

      turnNewValueBlurEvent (moneyValue) {
        this.newValue = moneyValue
      },

      onSelectMode (mode) {
        this.updateMode = mode
      },

      onAgreeCheckboxClick () {
        this.agree = !this.agree
      },

      //
      // ALTERAR VALOR DO TURNO E PLANTÕES (SE NECESSÁRIO)
      //

      saveTurnValue ()
      {
        if ((this.agree === false && this.updateMode === 'sim-todos') || this.updating === true) return false

        const value = this.newValue

        if (this.updateMode === 'nao')
        {
          this.updating = true

          apiUpdateScaleTurnValue(this.groupID, this.scaleID, this.shiftID, value, response => {
            this.updating = false
            if (response.code !== 0) this.$emit('changed', { id: this.shiftID, newValue: value })
            this.showMessage(response.code === 0 ? 'Erro' : 'Sucesso', response.message)
            this.close()
          })
        }
        else
        {
          const correctMonth = this.mes + 1

          const mes = this.updateMode === 'sim-mes-atual' ? String(correctMonth).padStart(2, '0') : false
          const ano = this.updateMode === 'sim-mes-atual' ? this.ano : false

          const turn = this.shifts.find(t => t.id === this.shiftID)
          if (!turn) return false

          this.updating = true

          // SENHOR JESUS - Reativar
          apiUpdateTurnDutiesValue(this.groupID, this.scaleID, this.shiftID, valueToTime(turn.hour), value, mes, ano, response => {
            this.updating = false
            if (response.code !== 0) this.$emit('changed', { id: this.shiftID, newValue: value })
            this.showMessage(response.code === 0 ? 'Erro' : 'Sucesso', response.message)
            this.close()
          })
        }
      },
    },
  }

</script>

<style scoped lang="scss">

  .customMaxHeight {
    max-height: 400px;
  }

</style>
